module.exports = __webpack_public_path__ + "media/images/sports_icons/camping-75d33a84c71a0ffd5cae8715b6d51ffc.png";